import { TagFilter, VisibleTagFilter } from 'server/config-cache/types';
import { CatalogsQuery } from '../ts/@types/generated/graphql/catalog-service/graphql';

/**
 * Maps through both tags from catalog and from config, and returns unique values that appear in both sets
 * @param tagsFromCatalog
 * @param tagsFromConfig
 * @returns
 */
export const getDietaryTemplatesFromTConfig = (
  tagsFromCatalog: TagFilter[],
  tagsFromConfigArg: VisibleTagFilter[] | undefined,
  tagFilterOption: 'funnel' | 'postCheckout',
): TagFilter[] => {
  const tagsFromConfig = tagsFromConfigArg?.filter((tag) => {
    return tagFilterOption === 'funnel'
      ? tag?.showInFunnel
      : tag?.showInCustomizer;
  });
  const filteredTags: TagFilter[] = [];
  tagsFromCatalog?.forEach((tagFromCatalog) => {
    tagsFromConfig?.forEach((tagFromConfig) => {
      if (
        tagFromCatalog.id === tagFromConfig.tag.id ||
        tagFromCatalog?.value?.toLowerCase() ===
          tagFromConfig?.tag.value?.toLowerCase()
      ) {
        //construct object, with tagFromConfig?.displayAs as value or displayValue
        filteredTags.push({
          category: tagFromCatalog.category,
          value: tagFromCatalog.value,
          displayValue: tagFromConfig.displayAs ?? tagFromCatalog.displayName,
          displayName: tagFromCatalog.displayName,
          id: tagFromCatalog.id,
        });
      }
    });
  });
  return filteredTags;
};

/**
 * Returns a map of delivery dates to an array of variant ids that are sold out
 * @param catalogs
 * @returns Record<string, Array<number>>
 */
export const getSoldOutItemMap = (
  catalogs: CatalogsQuery['catalogs'][0][],
): Record<string, Array<number>> => {
  return catalogs.reduce((acc, catalog) => {
    const soldOutItemVariantIds = catalog.items
      .filter((item) => item && item.soldOut)
      .map((item) => item!.variant.id as number);

    if (soldOutItemVariantIds.length > 0) {
      acc = {
        ...acc,
        // currently there is only ever one eligible delivery date per catalog
        // there is a @todo later in the code to possibly support multiple which
        // would apply to this as well
        [catalog.eligibleDeliveryDates[0]]: soldOutItemVariantIds,
      };
    }

    return acc;
  }, {});
};
